export default "__VITE_ASSET__BsMZhT_r__"